import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import trans from 'counterpart'
import Image from '../../media/components/Image'
import { createCompareUrl } from '../utils'
import { setCompareProperty, returnResourcesAfterRemoval, returnResourcesAfterAdd } from '../actions'
import { MAX_COMPARE } from '../constants'
import { getAccommodationTypes } from '../../../selectors/entitySelectors'

class ComparableResources extends Component {
  getAccommodationsByResortId = (id) => {
    const { accommodationTypes } = this.props
    return Object.values(accommodationTypes).filter(accommodation => accommodation.resort.id === id)
  }

  addToCompareResources = (id) => {
    const { addToCompareList, compareListIds, setHasMaxCompare, history } = this.props
    if (compareListIds.length === MAX_COMPARE) {
      return setHasMaxCompare(true)
    }
    const newResources = addToCompareList(id)
    return history.push(`${history.location.pathname}?${createCompareUrl({ resources: newResources })}`)
  }

  removeFromCompareResources = (id) => {
    const { removeFromCompareList, history } = this.props
    const newResources = removeFromCompareList(id)
    history.push(`${history.location.pathname}?${createCompareUrl({ resources: newResources })}`)
  }

  handleOnClick = (id) => {
    const { compareListIds } = this.props
    if (compareListIds.indexOf(id) > -1) {
      return this.removeFromCompareResources(id)
    }
    return this.addToCompareResources(id)
  }

  render () {
    const { compareListIds } = this.props
    return (
      <div id='comparable-resources' className='pt-5'>
        <h2 className='text-center'>{trans('label.choose_accommodation_to_compare')}</h2>
        {process.env.RAZZLE_APP === 'beeksebergen' && (
          <>
            <h3 className='mb-4 font-weight-normal text-center'>{trans('resort.safari_resort')}</h3>
            <div className='section-content thumbnails-md thumbnails-info'>
              <div className='row card-group card-group-md card-group-compare'>
                {this.getAccommodationsByResortId(2041).map(accommodation => (
                  <div className='card card-white' key={accommodation.id}>
                    <div className='compare' onClick={() => this.handleOnClick(accommodation.id)}>
                      <div className='card-media'>
                        <div className='card-media'>
                          {accommodation.images && accommodation.images.length > 0 && (
                            <Image
                              file={accommodation.images[0].reference}
                              filter='sm_43'
                              attr={{
                                className: 'card-img img-fluid',
                                alt: accommodation.name
                              }}
                            />
                          )}
                          {compareListIds.includes(accommodation.id) && (
                            <div className='result-selected in'><span /></div>
                          )}
                        </div>
                      </div>
                      <div className='card-block'>
                        <span className='card-header'>
                          <h4>{accommodation.display_name || accommodation.name}</h4>
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <h3 className='mb-4 font-weight-normal text-center'>{trans('resort.vakantiepark')}</h3>
            <div className='section-content thumbnails-md thumbnails-info'>
              <div className='row card-group card-group-md card-group-compare'>
                {this.getAccommodationsByResortId(21).map(accommodation => (
                  <div className='card card-white' key={accommodation.id}>
                    <div className='compare' onClick={() => this.handleOnClick(accommodation.id)}>
                      <div className='card-media'>
                        {accommodation.images && accommodation.images.length > 0 && (
                          <Image
                            file={accommodation.images[0].reference}
                            filter='sm_43'
                            attr={{
                              className: 'card-img img-fluid',
                              alt: accommodation.name
                            }}
                          />
                        )}
                        {compareListIds.includes(accommodation.id) && (
                          <div className='result-selected in'><span /></div>
                        )}
                      </div>
                      <div className='card-block'>
                        <span className='card-header'>
                          <h4>{accommodation.display_name || accommodation.name}</h4>
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
        {process.env.RAZZLE_APP === 'dierenbos' && (
          <>
            <div className='section-content thumbnails-md thumbnails-info'>
              <div className='row card-group card-group-md card-group-compare'>
                {this.getAccommodationsByResortId(22).map(accommodation => (
                  <div className='card card-white' key={accommodation.id}>
                    <div className='compare' onClick={() => this.handleOnClick(accommodation.id)}>
                      <div className='card-media'>
                        <div className='card-media'>
                          {accommodation.images && accommodation.images.length > 0 && (
                            <Image
                              file={accommodation.images[0].reference}
                              filter='sm_43'
                              attr={{
                                className: 'card-img img-fluid',
                                alt: accommodation.name
                              }}
                            />
                          )}
                          {compareListIds.includes(accommodation.id) && (
                            <div className='result-selected in'><span /></div>
                          )}
                        </div>
                      </div>
                      <div className='card-block'>
                        <span className='card-header'>
                          <h4>{accommodation.display_name || accommodation.name}</h4>
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    )
  }
}

ComparableResources.propTypes = {
  accommodationTypes: PropTypes.object,
  addToCompareList: PropTypes.func,
  compareListIds: PropTypes.array,
  history: PropTypes.object,
  removeFromCompareList: PropTypes.func,
  setHasMaxCompare: PropTypes.func
}

const mapStateToProps = state => ({
  accommodationTypes: getAccommodationTypes(state),
  compareListIds: state.compare.compareListIds
})

const mapDispatchToProps = dispatch => ({
  addToCompareList: id => dispatch(returnResourcesAfterAdd(id)),
  removeFromCompareList: id => dispatch(returnResourcesAfterRemoval(id)),
  setHasMaxCompare: bool => dispatch(setCompareProperty('hasMaxCompare', bool)),
  setHasIdInList: bool => dispatch(setCompareProperty('hasIdInList', bool))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ComparableResources))
